<template>
  <div class="createspd">
    <r-box class="createspd--formbox mb-9">
      <v-row>
        <v-col cols="7">
          <v-row>
            <v-col cols="12">
              <label class="d-block mb-1">
                {{ $t('dashboards.createDashboard.selectProduct') }}
              </label>
              <r-select
                :infinite="true"
                class="createspd--rselect"
                :items="items"
                :show-search="true"
                :allow-empty="true"
                @on:get-more="() => getProducts(true)"
                @change:search="onSearchChange"
                @change="onSelectProduct"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider class="my-4" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <r-text-field
                :value="name"
                :label="$t('dashboards.createDashboard.name')"
                placeholder="Samsung S10"
                @change="onChangeDashboardName"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="5"
          class="d-inline-flex align-center justify-end "
        >
          <div>
            <label class="createspd--template d-block pb-4">Selected Template</label>
            <r-dashboard-type-card
              :type="TYPES.SINGLE_PRODUCT"
              label="Single Product Deepdive"
            />
          </div>
        </v-col>
      </v-row>
    </r-box>
    <r-error-message :errors="[fetchCreateDashboardError]" />
    <v-row class="mt-3">
      <v-col>
        <div class="d-flex align-center justify-start mt-3">
          <span
            class="createspd--back-link"
            @click="$emit('back')"
          >
            Back
          </span>
        </div>
      </v-col>
      <v-col>
        <div class="d-flex align-center justify-end">
          <r-button
            class="mr-2"
            :outlined="true"
            :label="$t('global.actions.cancel')"
            @click="$emit('cancel')"
          />
          <r-button
            :label="$t('dashboards.createDashboard.createDashboardBtn')"
            :disabled="isCreateDashboardBtnDisabled"
            :loading="fetchingCreateDashboard"
            @click="onCreateDashboard"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RBox from '@/components/library/molecules/RBox'
import RButton from '@/components/library/atoms/RButton'
import { TYPES_OF_DASHBOARD } from '@/utils/constants'
import RTextField from '@/components/library/molecules/RTextField'
import { mapActions, mapState, mapGetters } from 'vuex'
import RSelect from '@/components/library/molecules/RSelect'
import RErrorMessage from '@/components/library/atoms/RErrorMessage'
import { generateParams } from '@/utils/store'
import RDashboardTypeCard from './common/RDashboardTypeCard'

export default {
  name: 'CreateSingleProductDashboard',
  components: {
    RBox,
    RButton,
    RSelect,
    RTextField,
    RDashboardTypeCard,
    RErrorMessage,
  },
  data: () => ({
    name: '',
    productId: null,
    search: '',
  }),
  computed: {
    ...mapGetters('projects', [
      'selectedProjectId',
    ]),
    ...mapState('products', [
      'productsSummary',
    ]),
    ...mapState('dashboards', [
      'fetchingCreateDashboard',
      'fetchCreateDashboardError',
    ]),
    items() {
      return this.productsSummary.map(({ _id, name }) => ({
        label: name,
        value: _id,
        selected: false,
      }))
    },
    isCreateDashboardBtnDisabled() {
      return !(this.name && this.productId)
    },
  },
  watch: {
    selectedProjectId() {
      this.getProducts()
    },
  },
  created() {
    this.TYPES = TYPES_OF_DASHBOARD
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    ...mapActions('products', [
      'fetchProductsSummary',
    ]),
    getProducts(isInfinityScroll = false, fromSearch = false) {
      let params = {
        projectId: this.selectedProjectId,
        isInfinityScroll,
        search: this.search,
      }
      if (fromSearch) {
        params = { ...params, page: 1 }
        return this.fetchProductsSummary(params)
      }
      if (isInfinityScroll) {
        const pageParams = generateParams('products')
        if (!pageParams) {
          return undefined
        }
        params = { ...params, ...pageParams }
        return this.fetchProductsSummary(params)
      }
      return this.fetchProductsSummary(params)
    },
    onChangeDashboardName({ value }) {
      this.name = value
    },
    onSelectProduct({ value }) {
      this.productId = value
    },
    async onCreateDashboard() {
      this.$emit('create', {
        name: this.name,
        productIds: [this.productId],
      })
    },
    onSearchChange({ value }) {
      this.search = value
      this.getProducts(false, true)
    },
  },
}
</script>

<style scoped>
.createspd--formbox {
  box-shadow: none;
}

.createspd--template {
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
}

.createspd--back-link {
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03px;
  color: var(--primary-color);
}
</style>
